import { Link } from 'react-router-dom';
import { Clock } from 'lucide-react';
const BACKEND = process.env.REACT_APP_BACKEND_URL;

// Style 1: ZIGZAG — alternating image/text rows. Used for Hrvatska vijesti, Crna kronika, Sport.
export default function Style1Block({ category, articles }) {
  if (!articles || articles.length === 0) return null;
  const color = category?.color || '#dc2626';
  const list = articles.slice(0, 5);

  return (
    <div className="space-y-5" data-testid="style1-zigzag">
      {list.map((a, i) => {
        const imgUrl = a.cover_image_url?.startsWith('http') ? a.cover_image_url : (a.cover_image_url ? `${BACKEND}${a.cover_image_url}` : null);
        const date = a.published_at ? new Date(a.published_at).toLocaleDateString('hr') : '';
        const reverse = i % 2 === 1;
        return (
          <article key={a.id} className={`grid md:grid-cols-5 gap-5 items-center group ${reverse ? 'md:[&>*:first-child]:order-2' : ''}`} data-testid={`style1-row-${i}`}>
            <Link to={`/clanak/${a.slug}`} className="md:col-span-2 block aspect-[16/10] rounded-lg overflow-hidden bg-gray-100 dark:bg-[#111827]">
              {imgUrl && <img src={imgUrl} alt="" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" loading="lazy" />}
            </Link>
            <div className="md:col-span-3">
              <span className="inline-block text-[10px] font-bold uppercase tracking-wider text-white px-2 py-0.5 rounded mb-2" style={{ backgroundColor: color }}>{category.name_hr}</span>
              <h3 className="text-lg md:text-xl font-extrabold leading-tight text-gray-900 dark:text-gray-100 group-hover:text-red-600 transition-colors">
                <Link to={`/clanak/${a.slug}`}>{a.title_hr}</Link>
              </h3>
              {a.excerpt_hr && <p className="text-sm text-gray-600 dark:text-gray-400 line-clamp-2 mt-2 leading-relaxed">{a.excerpt_hr}</p>}
              <div className="mt-3 flex items-center gap-3 text-[11px] text-gray-400 dark:text-gray-500">
                {date && <span className="flex items-center gap-1"><Clock size={11} />{date}</span>}
                {typeof a.views === 'number' && <span>{a.views} pregleda</span>}
              </div>
            </div>
          </article>
        );
      })}
    </div>
  );
}
